<template>
  <el-dialog
    title="新增订单评论"
    :visible.sync="dialogVisible"
    width="800px"
    :close-on-click-modal="false"
    :max-height="600"
  >
    <div class="form-container">
      <el-form :model="form" label-width="90px">
        <el-form-item label="商品" prop="goodsId">
          <div class="upload-box small" @click="uploadGoods">
            <template v-if="form.goodsImage">
              <img :src="form.goodsImage" class="goods-image" />
            </template>
            <template v-else>
              <i class="el-icon-plus"></i>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="用户头像" prop="userImage">
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.BRAND"
            @valueFunc="getImgsValueFunc"
            paramsType="userImage"
            :model="userImage"
            :maxCount="1"
          />
        </el-form-item>
        <div class="form-row">
          <el-form-item label="用户昵称" prop="userName">
            <el-input v-model="form.userName" placeholder="请输入用户昵称" class="short-input" />
          </el-form-item>
          <el-form-item label="订单ID" prop="orderId">
            <el-input v-model="form.orderId" placeholder="请输入订单ID" class="short-input" />
          </el-form-item>
        </div>
        <el-form-item label="评论内容" prop="content">
          <el-input
            type="textarea"
            v-model="form.content"
            placeholder="请输入评价内容"
            :rows="3"
            class="full-input"
          />
        </el-form-item>
        <el-form-item label="评分" prop="rating">
          <el-rate style="margin-top:10px" v-model="form.rating" :max="5" text-color="#f5a623" />
        </el-form-item>
        <el-form-item label="评论图片" prop="images">
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.BRAND"
            @valueFunc="getImgsValueFunc"
            paramsType="images"
            :model="imagesList"
            :maxCount="9"
            :width="'70px'"
            :height="'70px'"
          />
          <span class="image-count">最多上传9张图片</span>
        </el-form-item>
      </el-form>
    </div>

    <SelectProductModal
      ref="selectProductModal"
      :visible.sync="selectProductVisible"
      @confirm="handleSelectProduct"
    />

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addOrderReviews } from "@/api/goodsReview";
import { UPLOAD_IMG_TYPE } from "@/utils/enumUtile";
import UploadList from "@/views/components/uploadList.vue";
import SelectProductModal from "./SelectProductModal.vue";

export default {
  name: "AddOrderReview",
  components: { SelectProductModal, UploadList },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        userName: "",
        userImage: "",
        goodsId: "",
        goodsName: "",
        goodsImage: "",
        orderId: "",
        rating: 0,
        content: ""
      },
      imagesList: [],
      userImage: [],
      selectProductVisible: false
    };
  },
  computed: {
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.resetForm();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.selectProductVisible = false;
        this.$emit("update:visible", false);
      }
    }
  },
  methods: {
    resetForm() {
      this.form = {
        userName: "",
        goodsId: "",
        goodsName: "",
        goodsImage: "",
        orderId: "",
        rating: 0,
        content: ""
      };
      this.imagesList = [];
      this.userImage = [];
      if (this.$refs.selectProductModal) {
        this.$refs.selectProductModal.resetSelect();
      }
    },
    uploadGoods() {
      this.selectProductVisible = true;
    },
    handleSelectProduct(product) {
      this.form.goodsId = product.id;
      this.form.goodsName = product.name;
      this.form.goodsImage = product.mainGraph;
    },
    getImgsValueFunc(type, value) {
      if (type === "userImage") {
        this.userImage = value;
      } else if (type === "images") {
        this.imagesList = value;
      }
    },
    handleCancel() {
      this.selectProductVisible = false;
      this.dialogVisible = false;
    },
    handleSubmit() {
      if (!this.form.userName) {
        this.$message({ type: "warning", message: "请输入用户昵称" });
        return;
      }
      if (!this.form.goodsId) {
        this.$message({ type: "warning", message: "请选择商品" });
        return;
      }
      if (!this.form.orderId) {
        this.$message({ type: "warning", message: "请输入订单ID" });
        return;
      }
      if (!this.form.rating) {
        this.$message({ type: "warning", message: "请选择评分" });
        return;
      }
      if (!this.form.content) {
        this.$message({ type: "warning", message: "请输入评价内容" });
        return;
      }
      addOrderReviews({
        userName: this.form.userName,
        userImage: this.userImage[0]?.url || "",
        goodsId: this.form.goodsId,
        orderId: this.form.orderId,
        rating: this.form.rating,
        content: this.form.content,
        images: this.imagesList.map(item => item.url).join(",") || ""
      }).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.$message({ type: "success", message: "新增成功" });
          this.dialogVisible = false;
          this.$emit("success");
        } else {
          this.$message({ type: "error", message: resp.msg || "新增失败" });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.form-container {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 10px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-row .el-form-item {
  flex: 1;
}

.upload-box {
  width: 70px;
  height: 70px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  overflow: hidden;

  &:hover {
    border-color: #409eff;
    background-color: #f5f7fa;
  }

  .el-icon-plus {
    font-size: 24px;
    color: #c0c4cc;
  }

  .goods-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
  }
}

.upload-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .el-upload--picture-card {
    width: 70px;
    height: 70px;
    line-height: 70px;
  }

  .el-upload-list--picture-card {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 0;

    .el-upload-list__item {
      width: 70px;
      height: 70px;
      margin: 0;
    }
  }
}

.image-count {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.el-form-item {
  margin-bottom: 15px;
}

.el-form-item__label {
  font-weight: bold;
  font-size: 13px;
}

.short-input {
  width: 100%;
}

.full-input {
  width: 100%;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
